import ContentLoader from './ContentLoader';
import ContentLoaderContainer from './ContentLoader.container';

export default ContentLoaderContainer(ContentLoader);
